<!-- 收发存明细表（出入库明细） -->
<template>
    <div style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="stockInOutDetailForm" :model="stockInOutDetailForm"
        size="mini" label-width="100px">
            <el-form-item label="出入库类型" prop="ioType">
                <el-select placeholder="请选择出入库类型" v-model="stockInOutDetailForm.ioType" clearable>
                    <el-option v-for="item in ioTypeList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="stockInOutDetailForm.ckName" @change="changeCkName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库区" prop="place">
                <el-select class="width_100" @change="placeEnter" v-model="stockInOutDetailForm.place" placeholder="请选择库区" clearable>
                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库位" prop="location">
                <el-select class="width_100" filterable v-model="stockInOutDetailForm.location" placeholder="请选择库位" clearable>
                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo">
                <el-input v-model="stockInOutDetailForm.blNo" placeholder="请输入提单号" clearable style="width: 100%;" ></el-input>
            </el-form-item>
            <el-form-item label="货物名称" prop="goodsName">
                <el-select filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="stockInOutDetailForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsType }}</span>
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span >{{ item.hsCode }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="海关编码" prop="hsCode">
                <el-input v-model="stockInOutDetailForm.hsCode" placeholder="请输入海关编码" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="是否保税" prop="isBonded">
                <el-select placeholder="请选择" v-model="stockInOutDetailForm.isBonded" clearable>
                    <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报关单号" prop="cusDeclNo">
                <el-input v-model="stockInOutDetailForm.cusDeclNo" placeholder="请输入报关单号" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="核注清单号" prop="invDecNo">
                <el-input v-model="stockInOutDetailForm.invDecNo" placeholder="请输入核注清单号" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="项号" prop="itemNo">
                <el-input v-model="stockInOutDetailForm.itemNo" placeholder="请输入项号" clearable style="width: 100%;"></el-input>
            </el-form-item>
             <el-form-item label="日期范围" prop="date">
                <el-date-picker v-model="stockInOutDetailForm.date" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="pickerOptions" @change="changeDate" style="width: 250px">
                </el-date-picker>
                <span style="color: #909399; font-size: 12px; margin-left: 6px;">最多六个月</span>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="wmsGetStockInOutDetail">搜索</el-button>
                <el-button type="primary" @click="resetForm">重置</el-button>
                <el-button type="primary" @click="stockInOutDetailExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex: 1; overflow: hidden;">
            <vxe-table id="stockInOutDetailTable" size="mini" ref="stockInOutDetailTable" :data="stockInOutDetailList"
            border stripe header-align="center" max-height="100%" show-overflow show-header-overflow
            :row-config="{ isCurrent: true, isHover: true }">
                <vxe-column type="seq" title="序号" width="60"></vxe-column>
                <vxe-column field="ioType" title="出入库类型" width="100"></vxe-column>
                <vxe-column field="opTime" title="操作时间" width="150"></vxe-column>
                <vxe-column field="taskNo" title="任务单号" min-width="160"></vxe-column>
                <vxe-column field="ckName" title="仓库" width="140"></vxe-column>
                <vxe-column field="place" title="库区" width="100"></vxe-column>
                <vxe-column field="location" title="库位" width="90"></vxe-column>
                <vxe-column field="blNo" title="提单号" min-width="160"></vxe-column>
                <vxe-column field="itemNo" title="项号" width="70"></vxe-column>
                <vxe-column field="hsCode" title="海关编码" width="130"></vxe-column>
                <vxe-column field="goodsName" title="货物名称" min-width="180"></vxe-column>
                <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
                <vxe-column field="isBonded" title="保税类型" width="90"></vxe-column>
                <vxe-column field="cusDeclNo" title="报关单号" min-width="160"></vxe-column>
                <vxe-column field="invDecNo" title="核注清单号" min-width="160"></vxe-column>
                <vxe-colgroup title="数量">
                    <vxe-column field="qty1" title="数量1" width="100" align="right"></vxe-column>
                    <vxe-column field="qty1Unit" title="单位" width="70" align="center"></vxe-column>
                    <vxe-column field="qty2" title="数量2" width="100" align="right"></vxe-column>
                    <vxe-column field="qty2Unit" title="单位" width="70" align="center"></vxe-column>
                </vxe-colgroup>
                <vxe-column field="netWeight" title="净重(吨)" width="120" align="right"></vxe-column>
                <vxe-column field="ownerName" title="货主" min-width="200"></vxe-column>
            </vxe-table>
        </div>
    </div>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import clean from 'lodash-clean';

export default {
    name: 'inboundReportDetails',
    mixins: [userProfile],
    components: {

    },
    watch: {

    },
    data() {
        return {
            stockInOutDetailForm: {
                ioType: "",
                ckName: "",
                place: "",
                location: "",
                blNo: "",
                goodsName: "",
                hsCode: "",
                isBonded: "",
                cusDeclNo: "",
                invDecNo: "",
                itemNo: "",
                date: "",
                startDate: "",
                endDate: "",
            },
            stockInOutDetailList: [],
            ioTypeList: ['入库', '出库'], // 出入库类型（为空查全部）
            ckNameList: [], // 仓库列表
            placeList: [], // 库区列表
            locationList: [], // 库位列表
            goodsList:[], // 货物列表
            bondedTypeList: [], // 保税属性列表
            pickerMinDate: "", // 日期选择器第一次点选的日期，用来限制最多只能选六个月
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                onPick: ({ maxDate, minDate }) => {
                    this.pickerMinDate = minDate ? new Date(minDate.getTime()) : ''
                    // 首尾日期都选完了，解除限制
                    if (maxDate) {
                        this.pickerMinDate = ''
                    }
                },
                disabledDate: (time) => {
                    // 不能查未来日期
                    const today = new Date();
                    today.setHours(23, 59, 59, 999);
                    if (time.getTime() > today.getTime()) {
                        return true;
                    }
                    // 选了开始日期后，只允许开始日期 ~ 开始日期往后六个月
                    if (!this.pickerMinDate) {
                        return false;
                    }
                    const startTime = this.pickerMinDate.getTime();
                    const maxTime = this.addSixMonths(this.pickerMinDate).getTime();
                    return time.getTime() < startTime || time.getTime() > maxTime;
                }
            },
        }
    },
    async created() {
        // 默认查询最近一周（接口没分页，日期范围最多一个月）
        const endDateObj = new Date()
        const startDateObj = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        this.stockInOutDetailForm.date = [startDateObj, endDateObj]
        this.stockInOutDetailForm.startDate = this.formatDate(startDateObj)
        this.stockInOutDetailForm.endDate = this.formatDate(endDateObj)
        await this.getckNameList()
        // 获取库区
        await this.getStore()
        await this.getIsBonded()
        await this.wmsGetStockInOutDetail()
    },
    mounted() {

    },
    methods: {
        // 日期转换
        formatDate(dateObj) {
            if (!dateObj) return ''
            const date = new Date(dateObj)
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        // 日期往后推六个月
        addSixMonths(dateObj) {
            const date = new Date(dateObj.getTime())
            date.setMonth(date.getMonth() + 6)
            return date
        },
        // 日期范围是否超过六个月
        isOverSixMonths(startDateObj, endDateObj) {
            return endDateObj.getTime() > this.addSixMonths(startDateObj).getTime()
        },
        // 日期选择后格式化查询参数
        changeDate(value) {
            if (!value || value.length !== 2 || !value[0] || !value[1]) {
                this.stockInOutDetailForm.startDate = ''
                this.stockInOutDetailForm.endDate = ''
                this.pickerMinDate = ''
                return
            }
            const startDateObj = value[0]
            const endDateObj = value[1]
            if (this.isOverSixMonths(startDateObj, endDateObj)) {
                this.$message.warning('日期范围最多只能选择六个月，请重新选择')
                this.pickerMinDate = ''
                this.stockInOutDetailForm.date = []
                this.stockInOutDetailForm.startDate = ''
                this.stockInOutDetailForm.endDate = ''
                return
            }
            this.stockInOutDetailForm.startDate = this.formatDate(startDateObj)
            this.stockInOutDetailForm.endDate = this.formatDate(endDateObj)
        },
        // 重置查询条件并重新查询
        resetForm() {
            const endDateObj = new Date()
            const startDateObj = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
            this.stockInOutDetailForm = {
                ioType: "",
                ckName: this.ckNameList[0] || "",
                place: "",
                location: "",
                blNo: "",
                goodsName: "",
                hsCode: "",
                isBonded: "",
                cusDeclNo: "",
                invDecNo: "",
                itemNo: "",
                date: [startDateObj, endDateObj],
                startDate: this.formatDate(startDateObj),
                endDate: this.formatDate(endDateObj),
            }
            this.pickerMinDate = ''
            this.stockInOutDetailForm.place = ''
            this.stockInOutDetailForm.location = ''
            this.locationList = []
            this.wmsGetStockInOutDetail()
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        },
        // 获取数据（接口无分页，日期范围最多一个月，空值条件不传）
        wmsGetStockInOutDetail() {
            if (!this.stockInOutDetailForm.startDate || !this.stockInOutDetailForm.endDate) {
                this.$message.warning('请先选择日期范围')
                return
            }
            const params = clean({
                ioType: this.stockInOutDetailForm.ioType,
                ckName: this.stockInOutDetailForm.ckName,
                place: this.stockInOutDetailForm.place,
                location: this.stockInOutDetailForm.location,
                blNo: this.stockInOutDetailForm.blNo,
                goodsName: this.stockInOutDetailForm.goodsName,
                hsCode: this.stockInOutDetailForm.hsCode,
                isBonded: this.stockInOutDetailForm.isBonded,
                cusDeclNo: this.stockInOutDetailForm.cusDeclNo,
                invDecNo: this.stockInOutDetailForm.invDecNo,
                itemNo: this.stockInOutDetailForm.itemNo,
                startDate: this.stockInOutDetailForm.startDate,
                endDate: this.stockInOutDetailForm.endDate,
            })
            return this.$api.wmsGetStockInOutDetail(params).then(res => {
                this.stockInOutDetailList = res || []
            })
        },
        // 获取仓库
        getckNameList() {
            return this.$api.getCkNamesBy().then(res => {
                this.ckNameList = res
                this.stockInOutDetailForm.ckName = this.ckNameList[0]
            })
        },
        // 获取库区列表
        getStore(){
            return this.$api.getStore( this.stockInOutDetailForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 选择仓库后查询库区
        changeCkName(){
            if( this.stockInOutDetailForm.ckName){
                this.stockInOutDetailForm.place = ''
                this.stockInOutDetailForm.location = ''
                this.getStore()
            }
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.stockInOutDetailForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.stockInOutDetailForm.place = item[0]
                this.getLocation(item[1])
            }
            this.stockInOutDetailForm.location = ''
        },
        // 获取保税属性
        getIsBonded() {
            return this.$api.getDicList({ value: 'Wms保税属性' }).then(res => {
                this.bondedTypeList = res || []
            })
        },
        // 导出（导出当前查询出来的数据）
        async stockInOutDetailExport() {
            if (!this.stockInOutDetailList || this.stockInOutDetailList.length === 0) {
                this.$message.warning('没有可导出的数据，请先查询')
                return
            }
            const columnTitles = [
                '序号', '出入库类型', '操作时间', '任务单号', '仓库', '库区', '库位', '提单号', '项号',
                '海关编码', '货物名称', '规格型号', '保税类型', '报关单号', '核注清单号',
                '数量1', '单位', '数量2', '单位', '净重(吨)', '货主'
            ]
            const columnKeys = [
                'seq', 'ioType', 'opTime', 'taskNo', 'ckName', 'place', 'location', 'blNo', 'itemNo',
                'hsCode', 'goodsName', 'spec', 'isBonded', 'cusDeclNo', 'invDecNo',
                'qty1', 'qty1Unit', 'qty2', 'qty2Unit', 'netWeight', 'ownerName'
            ]
            // 数值列，导出成数字方便在excel里求和
            const numberKeys = ['qty1', 'qty2', 'netWeight']
            const columnWidths = [8, 12, 20, 20, 14, 10, 10, 18, 8, 16, 22, 18, 10, 20, 20, 12, 8, 12, 8, 14, 26]
            const ckName = this.stockInOutDetailForm.ckName || '全部仓库'

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('收发存明细表')
            const lastColName = worksheet.getColumn(columnTitles.length).letter

            const allBorder = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }

            // 标题
            const titleRow = worksheet.addRow([ckName + '收发存明细表'])
            worksheet.mergeCells(`A1:${lastColName}1`)
            titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' }
            titleRow.getCell(1).font = { bold: true, size: 16 }
            titleRow.height = 30

            // 查询条件
            const infoRow = worksheet.addRow([
                `日期范围：${this.stockInOutDetailForm.startDate} 至 ${this.stockInOutDetailForm.endDate}　　出入库类型：${this.stockInOutDetailForm.ioType || '全部'}　　保税类型：${this.stockInOutDetailForm.isBonded || '全部'}`
            ])
            worksheet.mergeCells(`A2:${lastColName}2`)
            infoRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' }
            infoRow.getCell(1).font = { bold: true, size: 12 }
            infoRow.height = 20

            // 表头
            const headerRow = worksheet.addRow(columnTitles)
            headerRow.eachCell((cell) => {
                cell.font = { bold: true }
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
                cell.border = allBorder
            })
            headerRow.height = 24

            // 数据
            this.stockInOutDetailList.forEach((item, index) => {
                const rowData = columnKeys.map(key => {
                    if (key === 'seq') {
                        return index + 1
                    }
                    const value = item[key]
                    if (value === null || value === undefined) {
                        return ''
                    }
                    if (numberKeys.indexOf(key) > -1) {
                        const num = Number(value)
                        return isNaN(num) ? value : num
                    }
                    return value
                })
                const dataRow = worksheet.addRow(rowData)
                dataRow.height = 20
                dataRow.eachCell((cell) => {
                    cell.border = allBorder
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: false }
                })
            })

            // 列宽
            columnWidths.forEach((width, index) => {
                worksheet.getColumn(index + 1).width = width
            })

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `${ckName}收发存明细表_${this.stockInOutDetailForm.startDate}_${this.stockInOutDetailForm.endDate}.xlsx`
            link.click()
            window.URL.revokeObjectURL(url)
        },
    }
}
</script>
<style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.margin_right_20{
    margin-right: 20px;
}
</style>
